import * as R from 'ramda'

class Settings {
    constructor({
        min,
        max,
        allowQuadrantAnalysis = true,
        decimals = 0,
        format = 'numeric',
    }) {
        this.min = min
        this.max = max
        this.allowQuadrantAnalysis = allowQuadrantAnalysis
        this.decimals = decimals
        this.format = format
    }

    toJSON() {
        return {
            min: R.isEmpty(this.min) ? undefined : this.min,
            max: R.isEmpty(this.max) ? undefined : this.max,
            allowQuadrantAnalysis: this.allowQuadrantAnalysis,
            decimals: R.or(this.decimals, 0),
            format: this.format,
        }
    }
}

export default Settings
